import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavComponent } from './core/components/nav/nav.component';
import { ToastContainerComponent } from "./shared/components/toast-container.component";
import { ConfirmationDialogContainerComponent } from "./shared/components/confirmation-dialog-container/confirmation-dialog-container.component";
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NavComponent, ToastContainerComponent, ConfirmationDialogContainerComponent],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.css'
})
export class AppComponent {
  constructor() {
    if (Capacitor.isNativePlatform()) {
      this.configureStatusBar();
      if (Capacitor.getPlatform() === 'ios') {
        // Tag the document so CSS can scope native-iOS-only tweaks
        // (e.g. modal headers that need to read white against the status bar).
        document.documentElement.classList.add('ios-native');
      }
    }
  }

  private async configureStatusBar(): Promise<void> {
    // Naming is counter-intuitive in @capacitor/status-bar:
    //   Style.Light → light BACKGROUND, dark icons (black time/battery)
    //   Style.Dark  → dark BACKGROUND, light icons (white)
    // We want a white bar with visible icons, so Light.
    try {
      await StatusBar.setStyle({ style: Style.Light });
      await StatusBar.setOverlaysWebView({ overlay: false });
      await StatusBar.setBackgroundColor({ color: '#ffffff' });
    } catch (err) {
      console.warn('StatusBar configuration failed:', err);
    }
  }
}
